{
  "seo": {
    "title": "For Schools — Classroom Learning Made Fun",
    "description": "Bring CuriPop to your classroom! Easy setup, classroom-ready content, printables, and no ads. Perfect for K-8 educators.",
    "keywords": "educational tool for schools, classroom learning app, K-8 education, teacher resources, classroom printables"
  },
  "hero": {
    "tagline": "Built for Educators",
    "titlePrefix": "Ignite Curiosity in Your",
    "titleHighlight": "Classroom",
    "subtitle": "Give your students a safe, engaging platform to explore their questions and build critical thinking skills. Trusted by educators to spark wonder.",
    "primaryCta": "Contact Us for Pricing",
    "secondaryCta": "Preview Content",
    "disclaimer": "✓ 30-Day Free Trial • ✓ No Credit Card Required • ✓ Setup in Minutes"
  },
  "trust": {
    "items": [
      "COPPA & FERPA Compliant",
      "Student Privacy Protected",
      "Trusted by Schools",
      "Award-Winning Content"
    ]
  },
  "sections": {
    "features": {
      "titlePrefix": "Everything",
      "titleHighlight": "Educators Need",
      "subtitle": "CuriPop is designed to fit seamlessly into your classroom workflow while maximizing student engagement."
    },
    "useCases": {
      "titlePrefix": "Flexible for",
      "titleHighlight": "Any Classroom",
      "subtitle": "From bell ringers to homework, CuriPop adapts to your teaching style."
    },
    "benefits": {
      "titlePrefix": "Proven Classroom",
      "titleHighlight": "Impact"
    },
    "testimonials": {
      "tagline": "Loved by Teachers",
      "title": "What Educators Are Saying"
    }
  },
  "features": {
    "items": [
      {
        "title": "Classroom-Ready Content",
        "description": "1,000+ questions covering STEM topics, social studies, and critical thinking skills for K-8 classrooms."
      },
      {
        "title": "Class Codes for Students",
        "description": "Students join with a simple class code and PIN—no email accounts required."
      },
      {
        "title": "School Portal",
        "description": "Manage printables and integration connections from a lightweight staff portal."
      },
      {
        "title": "Printable Classroom Kits",
        "description": "Download teacher-ready worksheets, answer keys, and printable activities for offline lessons and homework."
      },
      {
        "title": "COPPA & FERPA Compliant",
        "description": "Built with student privacy first. No ads, no data sharing, and full compliance with educational privacy regulations."
      },
      {
        "title": "Instant Engagement",
        "description": "Students can start exploring immediately—no lengthy onboarding. Perfect for independent learning time or homework."
      },
      {
        "title": "Flexible Implementation",
        "description": "Use as a warm-up activity, homework resource, or enrichment tool. Works on any device with zero IT overhead."
      }
    ]
  },
  "useCases": {
    "items": [
      {
        "title": "Morning Work & Bell Ringers",
        "description": "Start each day with a fascinating question to spark curiosity and get students thinking."
      },
      {
        "title": "Independent Learning Centers",
        "description": "Perfect for literacy centers, STEM stations, or enrichment activities during rotations."
      },
      {
        "title": "Homework & Extension",
        "description": "Assign questions as homework or for students who finish early—learning that's actually engaging."
      },
      {
        "title": "Cross-Curricular Projects",
        "description": "Use questions to launch research projects, writing prompts, or class discussions across subjects."
      }
    ]
  },
  "benefits": {
    "items": [
      {
        "title": "Bite-Sized Learning",
        "description": "Short questions, quizzes, and fun facts fit into warm-ups or learning centers."
      },
      {
        "title": "Boost Engagement",
        "description": "Interactive quizzes and fun facts keep students motivated and excited about learning."
      },
      {
        "title": "Growing Library",
        "description": "Questions added regularly, covering diverse topics to support cross-curricular learning."
      },
      {
        "title": "Build Curiosity",
        "description": "Foster a love of learning with content designed to spark wonder and encourage exploration."
      }
    ]
  },
  "testimonials": {
    "items": [
      {
        "quote": "My students beg to use CuriPop during independent work time. It's the perfect blend of fun and educational.",
        "author": "Sarah M.",
        "role": "4th Grade Teacher"
      },
      {
        "quote": "Finally, an edtech tool that doesn't require hours of training. Set up took 5 minutes and my whole class was exploring.",
        "author": "James T.",
        "role": "Middle School Science"
      },
      {
        "quote": "The questions spark great discussions, and my students actually ask for more quizzes.",
        "author": "Maria L.",
        "role": "3rd Grade Teacher"
      }
    ]
  },
  "faq": {
    "tagline": "Frequently Asked Questions",
    "title": "Questions Educators Ask",
    "items": [
      {
        "question": "How does school pricing work?",
        "answer": "We offer volume-based licensing for schools with flexible pricing based on the number of students. Contact us for a custom quote tailored to your school's needs. Pricing includes unlimited access for all students and teachers, plus dedicated support."
      },
      {
        "question": "What grade levels is CuriPop suitable for?",
        "answer": "CuriPop is designed for elementary and middle school students (grades K-8). Content is accessible for younger students while remaining engaging for older ones, and teachers can guide students to topics, quizzes, and printables."
      },
      {
        "question": "How do students access CuriPop?",
        "answer": "Schools receive class codes for each classroom. Students enter a class code and PIN to join—no email addresses or personal information required."
      },
      {
        "question": "Can teachers track student progress?",
        "answer": "We record quiz and assignment activity so schools can review participation and progress summaries during onboarding."
      },
      {
        "question": "Is technical setup required?",
        "answer": "No! CuriPop is entirely web-based and works on any device with a browser. No downloads, no installations, no IT tickets. Students can access from school computers, tablets, or at home."
      },
      {
        "question": "What kind of support do schools receive?",
        "answer": "School licenses include priority email support, onboarding assistance for teachers, curriculum guides, and access to our educator community. We're here to ensure your success."
      }
    ]
  },
  "cta": {
    "title": "Ready to Transform Learning in Your Classroom?",
    "subtitle": "Join hundreds of schools using CuriPop to spark curiosity and build critical thinking skills.",
    "primary": "Get School Pricing",
    "secondary": "Start Free Trial",
    "footer": {
      "prefix": "Questions? Email us at",
      "email": "school@curipop.com"
    }
  }
}
